import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button
} from "@material-ui/core";
import { Row, Col } from "react-flexbox-grid";
import JsonDiffPatch from "components/JsonDiffPatch";

import Inspector from "react-json-inspector";

require("./json-inspector.css");

const ProcessLogDiffJSONModal = props => {
  const {
    jsonModalOpen,
    processLogSelectedRowIndex,
    modalDataDetails,
    onJSONModalClose
  } = props;
  if (!jsonModalOpen) return null;
  const processLogRow = modalDataDetails[processLogSelectedRowIndex];

  let hasOldRowAndNewRow = false;
  const hasReport =
    processLogRow.report && Object.keys(processLogRow.report).length;
  let newRowJson = {};
  let oldRowJson = {};
  let reportAction = "";

  if (hasReport) {
    oldRowJson = processLogRow.report.old_row;
    newRowJson = processLogRow.report.new_row;

    if (oldRowJson === "{}") oldRowJson = {};
    if (newRowJson === "{}") newRowJson = {};

    // If this is an update, show the diff between the old row and new row.
    // otherwise its an insert, just show new data.
    // or a discarded row, just show discarded data.
    hasOldRowAndNewRow =
      Object.keys(oldRowJson).length &&
      Object.keys(newRowJson).length &&
      processLogRow.report.action !== "Discard";

    switch (processLogRow.report.action) {
      case "Discard":
        reportAction = "Row Discarded";
        break;
      case "Keep":
        reportAction = "Row Updated";
        break;
      default:
    }
  }

  return (
    <Dialog
      fullWidth
      maxWidth={false}
      open={jsonModalOpen}
      scroll="body"
      onClose={onJSONModalClose}
    >
      <DialogTitle>{`${processLogRow.level}: ${processLogRow.hint} in table "${processLogRow.table}"`}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <p>
            <b>{processLogRow.message}</b>
          </p>
          <p>{processLogRow.detail}</p>
          {reportAction.length ? (
            <p>
              <b>{reportAction}</b>
            </p>
          ) : null}

          {hasReport ? (
            <Row>
              <Col xs={11}>
                <Inspector
                  data={newRowJson}
                  search={false}
                  isExpanded={() => true}
                />
              </Col>
            </Row>
          ) : null}

          {hasOldRowAndNewRow ? (
            <div style={{ marginTop: 10 }}>
              <b>The following changes have been made to the database :</b>
              <JsonDiffPatch left={oldRowJson} right={newRowJson} />
            </div>
          ) : null}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onJSONModalClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ProcessLogDiffJSONModal.defaultProps = {
  jsonModalOpen: false
};

ProcessLogDiffJSONModal.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  modalDataDetails: PropTypes.arrayOf(PropTypes.object).isRequired,
  processLogSelectedRowIndex: PropTypes.number.isRequired,
  onJSONModalClose: PropTypes.func.isRequired,
  jsonModalOpen: PropTypes.bool
};

export default ProcessLogDiffJSONModal;
